import Select from "components/ui/Select";
import { useAvailableGodowns } from "http-hooks/godown/useGodown";

export default function SelectGodown({
  label = "Godown",
  value,
  onChange,
  isClearable = true,
  isSearchable = true,
  includeAllGodowns = true,
  ...props
}) {
  const { data, isLoading } = useAvailableGodowns({ noPagination: "true", agstat: "1" });

  const godownOptions = data?.data?.map((godown) => ({
    value: godown.id,
    label: godown.name,
  })) || [];

  const options = includeAllGodowns
    ? [{ value: 0, label: "All Godowns" }, ...godownOptions]
    : godownOptions;

  return (
    <Select
      label={label}
      options={options}
      value={value}
      onChange={onChange}
      isLoading={isLoading}
      isClearable={isClearable}
      isSearchable={isSearchable}
      placeholder="Select godown..."
      {...props}
    />
  );
}
